import { createStore } from 'vuex';

// global store
import state from "./state";
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

export default createStore({
  state,
  mutations,
  actions,
  getters
});
